import { Button } from 'uikit'
import { useFetchData } from './useFetchData'

export const ExportExcel = ({ size, filter = {} }) => {
  const { mutate: getData, isPending: isLoading } = useFetchData(size, filter)
  return (
    <Button loading={isLoading} size="sm" width="100%" onClick={getData}>
      Выгрузить Excel
    </Button>
  )
}
